export default __webpack_public_path__ + "static/media/7b415a05-784a-4a4c-8c94-67e9288312f5.e538f0d7.woff";